<!-- Backdrop -->
<div
  class="fixed inset-0 z-[60] bg-black/40 transition-opacity duration-300"
  [class.opacity-100]="open"
  [class.pointer-events-auto]="open"
  [class.opacity-0]="!open"
  [class.pointer-events-none]="!open"
  (click)="close()"
></div>

<!-- Drawer -->
<aside
  class="fixed inset-y-0 right-0 z-[61] w-full max-w-3xl bg-gray-50 dark:bg-[#0e1726] shadow-2xl transition-transform duration-300 ease-out flex flex-col"
  [class.translate-x-0]="open"
  [class.translate-x-full]="!open"
  role="dialog"
  aria-modal="true"
>
  <!-- ================= HEADER ================= -->
  <div class="border-b border-gray-200 dark:border-white/10 bg-white dark:bg-black/20">
    <div class="flex items-start justify-between gap-3 p-4 md:p-5">
      <div class="flex items-center gap-4 min-w-0">
        <div class="h-16 w-24 shrink-0 rounded-xl bg-gradient-to-br from-slate-200 to-slate-300 dark:from-white/10 dark:to-white/5 grid place-content-center">
          <img *ngIf="vehicle?.icon" class="w-16 h-10 object-contain" [src]="vehicle?.icon" alt="vehículo" />
        </div>
        <div class="min-w-0">
          <div class="truncate text-lg font-bold text-[#0e1726] dark:text-white">
            {{ vehicle?.brand || 'Vehículo' }} {{ vehicle?.vehicle_model || '' }}
          </div>
          <div class="mt-1 flex flex-wrap items-center gap-2">
            <span class="rounded-md bg-gray-100 dark:bg-white/10 px-2 py-0.5 text-xs font-semibold uppercase tracking-wide text-gray-700 dark:text-white/80">
              {{ vehicle?.plate ? (vehicle?.plate | uppercase) : '—' }}
            </span>
            <span *ngIf="vehicle" class="inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold" [ngClass]="statusPillClass">
              <span class="h-1.5 w-1.5 rounded-full" [ngStyle]="{ 'background-color': statusMeta[vehicle.status_live].hex }"></span>
              {{ statusMeta[vehicle.status_live].label }}
            </span>
          </div>
        </div>
      </div>

      <button
        class="h-9 w-9 shrink-0 grid place-content-center rounded-full text-gray-500 hover:bg-gray-100 dark:text-white/70 dark:hover:bg-white/10"
        (click)="close()"
        aria-label="Cerrar"
      >
        <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M18 6 6 18M6 6l12 12" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
    </div>

    <!-- ================= TABS ================= -->
    <div class="flex gap-1 overflow-x-auto px-3 no-scrollbar">
      <button
        *ngFor="let t of tabs"
        (click)="setTab(t.key)"
        class="whitespace-nowrap border-b-2 px-3 py-2.5 text-sm font-semibold transition-colors"
        [ngClass]="
          activeTab === t.key
            ? 'border-primary text-primary'
            : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-white/60 dark:hover:text-white'
        "
      >
        {{ t.label }}
      </button>
    </div>
  </div>

  <!-- ================= BODY ================= -->
  <div class="flex-1 overflow-y-auto p-4 md:p-5">
    <!-- Estado vacío / cargando -->
    <div *ngIf="!vehicle" class="flex h-full flex-col items-center justify-center gap-3 text-gray-400 dark:text-white/50">
      <svg class="h-10 w-10 animate-pulse" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
        <path d="M3 13l1.5-4.5A2 2 0 0 1 6.4 7h11.2a2 2 0 0 1 1.9 1.5L21 13v5a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H6v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-5Z" stroke-linecap="round" stroke-linejoin="round" />
        <circle cx="7.5" cy="16" r="1" /><circle cx="16.5" cy="16" r="1" />
      </svg>
      <span class="text-sm">Selecciona un vehículo para ver su perfil</span>
    </div>

    <ng-container *ngIf="vehicle as v">
      <!-- ============ RESUMEN ============ -->
      <div *ngIf="activeTab === 'resumen'" class="space-y-5">
        <!-- Ficha técnica -->
        <div class="rounded-xl border border-gray-100 dark:border-white/10 bg-white dark:bg-white/5 shadow-sm p-4">
          <h3 class="mb-3 text-sm font-bold text-[#0e1726] dark:text-white">Ficha técnica</h3>
          <div class="grid grid-cols-2 gap-x-4 gap-y-3 sm:grid-cols-3">
            <div>
              <div class="text-[11px] uppercase tracking-wide text-gray-400 dark:text-white/40">Año</div>
              <div class="text-sm font-semibold text-[#0e1726] dark:text-white">{{ v.year || '—' }}</div>
            </div>
            <div>
              <div class="text-[11px] uppercase tracking-wide text-gray-400 dark:text-white/40">Tipo</div>
              <div class="text-sm font-semibold text-[#0e1726] dark:text-white">{{ v.typevehicle || '—' }}</div>
            </div>
            <div>
              <div class="text-[11px] uppercase tracking-wide text-gray-400 dark:text-white/40">Odómetro</div>
              <div class="text-sm font-semibold text-[#0e1726] dark:text-white">{{ cop(v.telemetry?.odometerKm ?? v.km) }} km</div>
            </div>
            <div>
              <div class="text-[11px] uppercase tracking-wide text-gray-400 dark:text-white/40">Ciudad</div>
              <div class="text-sm font-semibold text-[#0e1726] dark:text-white">{{ v.city?.name || '—' }}</div>
            </div>
            <div>
              <div class="text-[11px] uppercase tracking-wide text-gray-400 dark:text-white/40">Estado</div>
              <div class="text-sm font-semibold text-[#0e1726] dark:text-white">{{ v.state?.name || '—' }}</div>
            </div>
            <div>
              <div class="text-[11px] uppercase tracking-wide text-gray-400 dark:text-white/40">Ubicación</div>
              <div class="truncate text-sm font-semibold text-[#0e1726] dark:text-white">{{ v.addressLabel || '—' }}</div>
            </div>
          </div>
        </div>

        <!-- KPIs -->
        <div class="grid grid-cols-2 gap-3 lg:grid-cols-4">
          <div class="rounded-xl border border-gray-100 dark:border-white/10 bg-white dark:bg-white/5 shadow-sm p-4">
            <div class="text-[11px] uppercase tracking-wide text-gray-400 dark:text-white/40">Rendimiento</div>
            <div class="mt-1 text-xl font-bold text-[#0e1726] dark:text-white">{{ v.analytics.fuelEfficiencyKmpl }}<span class="ml-1 text-xs font-medium text-gray-400">km/l</span></div>
          </div>
          <div class="rounded-xl border border-gray-100 dark:border-white/10 bg-white dark:bg-white/5 shadow-sm p-4">
            <div class="text-[11px] uppercase tracking-wide text-gray-400 dark:text-white/40">Ralentí</div>
            <div class="mt-1 text-xl font-bold text-[#0e1726] dark:text-white">{{ v.analytics.idleTimeHours }}<span class="ml-1 text-xs font-medium text-gray-400">h</span></div>
          </div>
          <div class="rounded-xl border border-gray-100 dark:border-white/10 bg-white dark:bg-white/5 shadow-sm p-4">
            <div class="text-[11px] uppercase tracking-wide text-gray-400 dark:text-white/40">Costo / km</div>
            <div class="mt-1 text-xl font-bold text-[#0e1726] dark:text-white">${{ cop(v.analytics.costPerKm) }}</div>
          </div>
          <div class="rounded-xl border border-gray-100 dark:border-white/10 bg-white dark:bg-white/5 shadow-sm p-4">
            <div class="text-[11px] uppercase tracking-wide text-gray-400 dark:text-white/40">Score conductor</div>
            <div class="mt-1 text-xl font-bold text-[#0e1726] dark:text-white">{{ v.analytics.driverScore }}<span class="ml-1 text-xs font-medium text-gray-400">/100</span></div>
          </div>
        </div>

        <!-- Nivel de combustible -->
        <div class="rounded-xl border border-gray-100 dark:border-white/10 bg-white dark:bg-white/5 shadow-sm p-4">
          <div class="mb-2 flex items-center justify-between">
            <h3 class="text-sm font-bold text-[#0e1726] dark:text-white">Nivel de combustible</h3>
            <span class="text-sm font-semibold text-[#0e1726] dark:text-white">{{ v.telemetry?.fuelPct ?? 0 }}%</span>
          </div>
          <div class="h-3 w-full overflow-hidden rounded-full bg-gray-100 dark:bg-white/10">
            <div
              class="h-full rounded-full transition-all"
              [ngClass]="v.telemetry.fuelPct < 20 ? 'bg-red-500' : v.telemetry.fuelPct < 50 ? 'bg-amber-500' : 'bg-emerald-500'"
              [ngStyle]="{ width: v.telemetry.fuelPct + '%' }"
            ></div>
          </div>
        </div>
      </div>

      <!-- ============ MANTENIMIENTOS ============ -->
      <div *ngIf="activeTab === 'mantenimientos'" class="space-y-6">
        <section>
          <h3 class="mb-3 flex items-center gap-2 text-sm font-bold text-[#0e1726] dark:text-white">
            <svg class="h-4 w-4 text-amber-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 9v4m0 4h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Próximos / Alertas
          </h3>
          <div *ngIf="upcomingMaintenance.length; else noUpcoming" class="space-y-2">
            <div *ngFor="let m of upcomingMaintenance" class="rounded-xl border p-3.5 shadow-sm" [ngClass]="maintenanceCardClass(m)">
              <div class="flex items-start justify-between gap-2">
                <div>
                  <div class="font-semibold text-[#0e1726] dark:text-white">{{ m.type }}</div>
                  <div class="text-[11px] text-gray-500 dark:text-white/60">{{ m.date | date: 'dd/MM/yyyy' }} · {{ cop(m.km) }} km</div>
                </div>
                <span class="rounded-full px-2.5 py-0.5 text-[11px] font-semibold" [ngClass]="maintenanceBadgeClass(m)">{{ maintenanceStatusLabel(m) }}</span>
              </div>
              <div class="mt-2 flex flex-wrap items-center gap-x-4 text-xs text-gray-500 dark:text-white/60">
                <span *ngIf="m.workshop">{{ m.workshop }}</span>
                <span *ngIf="m.cost != null" class="font-semibold text-[#0e1726] dark:text-white">${{ cop(m.cost) }}</span>
              </div>
            </div>
          </div>
          <ng-template #noUpcoming>
            <div class="rounded-xl border border-dashed border-gray-200 dark:border-white/10 p-4 text-center text-sm text-gray-400 dark:text-white/50">Sin alertas próximas</div>
          </ng-template>
        </section>

        <section>
          <h3 class="mb-3 text-sm font-bold text-[#0e1726] dark:text-white">Historial</h3>
          <div *ngIf="historyMaintenance.length; else noHistory" class="space-y-2">
            <div
              *ngFor="let m of historyMaintenance"
              class="flex items-center justify-between gap-3 rounded-xl border border-gray-100 dark:border-white/10 bg-white dark:bg-white/5 shadow-sm p-3.5"
            >
              <div class="min-w-0">
                <div class="truncate font-semibold text-[#0e1726] dark:text-white">{{ m.type }}</div>
                <div class="text-[11px] text-gray-500 dark:text-white/60">
                  {{ m.date | date: 'dd/MM/yyyy' }} · {{ cop(m.km) }} km<span *ngIf="m.workshop"> · {{ m.workshop }}</span>
                </div>
              </div>
              <span *ngIf="m.cost != null" class="shrink-0 text-sm font-semibold text-[#0e1726] dark:text-white">${{ cop(m.cost) }}</span>
            </div>
          </div>
          <ng-template #noHistory>
            <div class="rounded-xl border border-dashed border-gray-200 dark:border-white/10 p-4 text-center text-sm text-gray-400 dark:text-white/50">Sin historial</div>
          </ng-template>
        </section>
      </div>

      <!-- ============ REPARACIONES ============ -->
      <div *ngIf="activeTab === 'reparaciones'">
        <app-maintenance-timeline [repairs]="v.repairs"></app-maintenance-timeline>
      </div>

      <!-- ============ GASTOS ============ -->
      <div *ngIf="activeTab === 'gastos'" class="space-y-4">
        <div class="flex items-center justify-between rounded-xl border border-gray-100 dark:border-white/10 bg-white dark:bg-white/5 shadow-sm px-4 py-3">
          <span class="text-sm font-semibold text-gray-500 dark:text-white/60">Total de gastos</span>
          <span class="text-lg font-bold text-[#0e1726] dark:text-white">${{ cop(expensesTotal) }}</span>
        </div>

        <div *ngIf="v.expenses?.length; else noExpenses" class="overflow-hidden rounded-xl border border-gray-100 dark:border-white/10 bg-white dark:bg-white/5 shadow-sm">
          <div
            *ngFor="let e of v.expenses; trackBy: trackByExpense"
            class="flex items-center justify-between gap-3 border-b border-gray-100 dark:border-white/10 px-4 py-3 last:border-0"
          >
            <div class="flex items-center gap-3 min-w-0">
              <span class="shrink-0 rounded-full px-2.5 py-0.5 text-[11px] font-semibold" [ngClass]="expenseCategoryClass(e.category)">
                {{ expenseCategoryLabel(e.category) }}
              </span>
              <div class="min-w-0">
                <div class="truncate text-sm font-medium text-[#0e1726] dark:text-white">{{ e.concept }}</div>
                <div class="text-[11px] text-gray-400 dark:text-white/50">{{ e.date | date: 'dd/MM/yyyy' }}</div>
              </div>
            </div>
            <span class="shrink-0 text-sm font-semibold text-[#0e1726] dark:text-white">${{ cop(e.amount) }}</span>
          </div>
        </div>
        <ng-template #noExpenses>
          <div class="rounded-xl border border-dashed border-gray-200 dark:border-white/10 p-6 text-center text-sm text-gray-400 dark:text-white/50">Sin gastos registrados</div>
        </ng-template>
      </div>

      <!-- ============ CONDUCTORES ============ -->
      <div *ngIf="activeTab === 'conductores'" class="space-y-2">
        <ng-container *ngIf="v.driverHistory?.length; else noDrivers">
          <div
            *ngFor="let d of v.driverHistory"
            class="flex items-center justify-between gap-3 rounded-xl border border-gray-100 dark:border-white/10 bg-white dark:bg-white/5 shadow-sm p-3.5"
          >
            <div class="flex items-center gap-3 min-w-0">
              <div class="h-10 w-10 shrink-0 overflow-hidden rounded-full bg-gray-100 dark:bg-white/10 grid place-content-center text-gray-500 dark:text-white/60">
                <img *ngIf="d.driver.avatar; else initials" class="h-full w-full object-cover" [src]="d.driver.avatar" [alt]="d.driver.name" />
                <ng-template #initials>
                  <span class="text-sm font-semibold">{{ (d.driver.name || '?').charAt(0) | uppercase }}</span>
                </ng-template>
              </div>
              <div class="min-w-0">
                <div class="truncate text-sm font-semibold text-[#0e1726] dark:text-white">{{ d.driver.name }}</div>
                <div class="text-[11px] text-gray-500 dark:text-white/60">
                  {{ d.from | date: 'dd/MM/yyyy' }} → {{ d.to ? (d.to | date: 'dd/MM/yyyy') : 'actual' }} · {{ cop(d.distanceKm) }} km
                </div>
              </div>
            </div>
            <span *ngIf="!d.to" class="shrink-0 rounded-full bg-emerald-500/10 px-2.5 py-0.5 text-[11px] font-semibold text-emerald-500">Actual</span>
          </div>
        </ng-container>
        <ng-template #noDrivers>
          <div class="rounded-xl border border-dashed border-gray-200 dark:border-white/10 p-6 text-center text-sm text-gray-400 dark:text-white/50">Sin conductores registrados</div>
        </ng-template>
      </div>

      <!-- ============ DOCUMENTOS ============ -->
      <div *ngIf="activeTab === 'documentos'">
        <ng-container *ngIf="v.details?.soatExpirationDate || v.details?.technicalReviewExpirationDate; else noDocs">
          <div class="grid gap-3 sm:grid-cols-2">
            <div *ngIf="v.details?.soatExpirationDate" class="rounded-xl border border-gray-100 dark:border-white/10 bg-white dark:bg-white/5 shadow-sm p-4">
              <div class="flex items-center gap-2 text-sm font-bold text-[#0e1726] dark:text-white">
                <svg class="h-4 w-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                SOAT
              </div>
              <div class="mt-2 text-[11px] uppercase tracking-wide text-gray-400 dark:text-white/40">Vencimiento</div>
              <div class="text-sm font-semibold text-[#0e1726] dark:text-white">{{ v.details?.soatExpirationDate | date: 'dd/MM/yyyy' }}</div>
            </div>

            <div *ngIf="v.details?.technicalReviewExpirationDate" class="rounded-xl border border-gray-100 dark:border-white/10 bg-white dark:bg-white/5 shadow-sm p-4">
              <div class="flex items-center gap-2 text-sm font-bold text-[#0e1726] dark:text-white">
                <svg class="h-4 w-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M9 11l3 3L22 4M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Revisión técnica
              </div>
              <div class="mt-2 text-[11px] uppercase tracking-wide text-gray-400 dark:text-white/40">Vencimiento</div>
              <div class="text-sm font-semibold text-[#0e1726] dark:text-white">{{ v.details?.technicalReviewExpirationDate | date: 'dd/MM/yyyy' }}</div>
            </div>
          </div>
        </ng-container>
        <ng-template #noDocs>
          <div class="rounded-xl border border-dashed border-gray-200 dark:border-white/10 p-6 text-center text-sm text-gray-400 dark:text-white/50">Sin documentos</div>
        </ng-template>
      </div>
    </ng-container>
  </div>
</aside>
